import Constants from '@/Constants';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { startCDNTestFailure, startCDNTestSuccess } from './action';

export function* startCDNTest() {
    try {
        const response = yield call(http.get, Constants.SCORM_CDN_TEST_START_URI);

        yield put(startCDNTestSuccess(response.data.url));
    } catch (err) {
        yield put(startCDNTestFailure(err));
    }
}
